if (!customElements.get('review-slider')) {
  class ReviewSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.review-slider-track');
      this.btnPrev = this.querySelector('.js-prev');
      this.btnNext = this.querySelector('.js-next');
      this.isAnimating = false;
      this.autoSlideInterval = null;

      this.init();
    }

    init() {
      if (!this.track || !this.btnPrev || !this.btnNext) return;

      // Check if we have enough items to loop properly
      if (this.track.children.length <= 1) {
        this.btnPrev.style.display = 'none';
        this.btnNext.style.display = 'none';
        return;
      }

      this.btnNext.addEventListener('click', () => {
        this.slideNext();
        this.resetAutoSlide();
      });
      this.btnPrev.addEventListener('click', () => {
        this.slidePrev();
        this.resetAutoSlide();
      });

      this.addEventListener('mouseenter', this.stopAutoSlide.bind(this));
      this.addEventListener('mouseleave', this.startAutoSlide.bind(this));
      
      this.startAutoSlide();
    }

    startAutoSlide() {
      this.stopAutoSlide(); // Ensure we don't have multiple intervals
      this.autoSlideInterval = setInterval(() => {
        this.slideNext();
      }, 3000);
    }

    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    }

    resetAutoSlide() {
      this.stopAutoSlide();
      this.startAutoSlide();
    }

    getCardWidth() {
      const card = this.track.firstElementChild;
      if (!card) return 0;
      // get actual width including gap
      const style = window.getComputedStyle(card);
      const width = card.offsetWidth;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      return width + gap;
    }

    slideNext() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      const cardWidth = this.getCardWidth();
      
      this.track.style.transition = 'transform 0.4s ease-in-out';
      this.track.style.transform = `translateX(-${cardWidth}px)`;

      const onTransitionEnd = () => {
        this.track.removeEventListener('transitionend', onTransitionEnd);
        
        // Move first element to end
        this.track.appendChild(this.track.firstElementChild);
        
        // Reset transform without transition
        this.track.classList.add('no-transition');
        this.track.style.transform = 'translateX(0)';
        
        // Force reflow
        void this.track.offsetWidth;
        
        this.track.classList.remove('no-transition');
        this.isAnimating = false;
      };

      this.track.addEventListener('transitionend', onTransitionEnd);
    }

    slidePrev() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      const cardWidth = this.getCardWidth();

      // Move last element to start instantly
      this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
      
      // Set initial position to simulate it was already off-screen to the left
      this.track.classList.add('no-transition');
      this.track.style.transform = `translateX(-${cardWidth}px)`;
      
      // Force reflow
      void this.track.offsetWidth;

      // Animate to 0
      this.track.classList.remove('no-transition');
      this.track.style.transition = 'transform 0.4s ease-in-out';
      this.track.style.transform = 'translateX(0)';

      const onTransitionEnd = () => {
        this.track.removeEventListener('transitionend', onTransitionEnd);
        this.isAnimating = false;
      };

      this.track.addEventListener('transitionend', onTransitionEnd);
    }
  }

  customElements.define('review-slider', ReviewSlider);
}
